/**
 * Three out dots, filled left to right for each out (ISSUE-1091). Theme
 * tokens only. Decorative: the server's sentence says the outs in words.
 */
import { cn } from "@sportsmet/ui";
import type { ReactNode } from "react";

export type typeOutsDotsProps = {
  outs: number;
  size: "row" | "panel";
};

const DOT_CENTERS = [3, 12, 21] as const;

export const OutsDots = (props: typeOutsDotsProps): ReactNode => {
  const filledCount = Math.max(0, Math.min(props.outs, DOT_CENTERS.length));
  return (
    <svg
      viewBox="0 0 24 6"
      aria-hidden="true"
      data-testid="outs-dots"
      className={cn(
        "shrink-0",
        props.size === "row" ? "h-1.5 w-6" : "h-3 w-12",
      )}
    >
      {DOT_CENTERS.map((cx, index) => {
        const isFilled = index < filledCount;
        return (
          <circle
            key={cx}
            cx={cx}
            cy={3}
            r={2.5}
            data-testid="out-dot"
            data-filled={isFilled ? "true" : "false"}
            strokeWidth={1}
            className={
              isFilled
                ? props.size === "row"
                  ? "fill-current text-primary"
                  : "fill-current text-ink"
                : "fill-none stroke-current text-ink-tertiary"
            }
          />
        );
      })}
    </svg>
  );
};
